Messages.RecipientFinder = function () {
  function RecipientFinder(el) {
    this.el = el;
    this._initialValue().always(function (_this) {
      return function (data) {
        return _this._initAutocomplete(data != null ? data.recipients : void 0);
      };
    }(this));
  }
  RecipientFinder.prototype._initAutocomplete = function (recipients) {
    var backboneRecipients, select2;
    new Search.UserSearch({
      el: this.el,
      placeholder: "Choose a recipient",
      minimumInputLength: 0,
      maximumSelectionSize: 5,
      limit: 25
    });
    this.el.trigger("resize_modal");
    select2 = this.el.data("select2");
    if (recipients) {
      backboneRecipients = _.map(recipients, function (_this) {
        return function (recipient) {
          return new Backbone.Model(recipient);
        };
      }(this));
      select2.updateSelection(backboneRecipients);
    }
    return select2.search.on("keyup", function (_this) {
      return function (e) {
        if (e.keyCode === 27) {
          e.stopPropagation();
          return select2.cancel();
        }
      };
    }(this));
  };
  RecipientFinder.prototype._initialValue = function () {
    var recipient_ids;
    if (recipient_ids = this.el.val()) {
      return $.ajax({
        url: $r.recipients_api_v0_messages_path({
          id: recipient_ids,
          subdomain_param: "api"
        }),
        dataType: "json"
      });
    } else {
      return {
        always: function (cb) {
          return cb();
        }
      };
    }
  };
  return RecipientFinder;
}();